import type { TaskStep } from '@camino-solutions/share/proto/common/services';

export class SessionTaskProcessingTaskStepAction {
  static readonly type = '[Session] Task processing: TaskStep';

  constructor(
    readonly cardId: string,
    readonly taskStep: TaskStep,
  ) {}
}
